import { useContext, useEffect } from 'react';
import { ScaleLine } from 'ol/control';
import MapContext from '../Map/MapContext';

const ScaleLineControl = () => {
    const { map } = useContext(MapContext);

    useEffect(() => {
        if (!map) return;

        let ScaleLineControl = new ScaleLine({});

        map.controls.push(ScaleLineControl);

        return () => map.controls.remove(ScaleLineControl);
    }, [map]);

    return null;
};

export default ScaleLineControl;
